import levelsData from '../gameLevels.json';

const getGameLevels = () => {
  return levelsData.levels;
};

export { getGameLevels };